export default "__VITE_ASSET__66c8d612__"